import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport } from "vue";
const _hoisted_1 = {
  class: "flex-1 flex flex-col min-w-0"
};
const _hoisted_2 = {
  class: "h-14 px-4 flex items-center justify-between border-b border-slate-200 bg-white flex-shrink-0"
};
const _hoisted_3 = {
  class: "flex items-center gap-3 min-w-0"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  key: 2,
  class: "w-8 h-8 rounded-full bg-violet-500 flex items-center justify-center flex-shrink-0"
};
const _hoisted_6 = {
  class: "min-w-0"
};
const _hoisted_7 = {
  class: "flex items-center gap-2"
};
const _hoisted_8 = {
  class: "text-sm font-semibold text-slate-800 truncate"
};
const _hoisted_9 = {
  key: 0,
  class: "px-1.5 py-0.5 text-[10px] leading-none rounded bg-primary-100 text-primary-600 flex-shrink-0"
};
const _hoisted_10 = {
  key: 1,
  class: "px-1.5 py-0.5 text-[10px] leading-none rounded bg-emerald-100 text-emerald-600 flex-shrink-0"
};
const _hoisted_11 = {
  key: 2,
  class: "px-1.5 py-0.5 text-[10px] leading-none rounded bg-violet-100 text-violet-600 flex-shrink-0"
};
const _hoisted_12 = {
  key: 0,
  class: "text-[11px] text-green-500"
};
const _hoisted_13 = {
  key: 1,
  class: "text-[11px] text-slate-400"
};
const _hoisted_14 = {
  class: "flex items-center gap-1"
};
const _hoisted_15 = {
  key: 0,
  class: "px-4 py-2 bg-white border-b border-slate-100 flex items-center gap-2"
};
const _hoisted_16 = {
  class: "relative flex-1"
};
const _hoisted_17 = {
  key: 0,
  class: "text-xs text-slate-500 flex-shrink-0"
};
const _hoisted_18 = {
  key: 0,
  class: "flex justify-center py-8"
};
const _hoisted_19 = {
  key: 0,
  class: "flex items-center justify-center py-2"
};
const _hoisted_20 = {
  class: "px-3 py-1 text-[11px] text-slate-400 bg-slate-200/60 rounded-full"
};
const _hoisted_21 = {
  key: 1,
  class: "flex justify-center py-1"
};
const _hoisted_22 = {
  class: "px-3 py-1 text-[11px] text-slate-400 bg-slate-200/60 rounded-full"
};
const _hoisted_23 = {
  key: 0,
  class: "flex justify-center py-8"
};
const _hoisted_24 = {
  class: "relative"
};
const _hoisted_25 = ["src"];
import { ref, computed, watch, nextTick } from 'vue';
import { useChatStore } from '@/stores/chat';
import { useUserStore } from '@/stores/user';
import MessageBubble from './MessageBubble.vue';
import ChatInput from './ChatInput.vue';
import AppModal from '@/components/AppModal.vue';
export default {
  __name: 'ChatArea',
  setup(__props) {
    const chatStore = useChatStore();
    const userStore = useUserStore();
    const currentUserId = computed(() => userStore.userInfo?.userId);
    const messagesContainer = ref(null);
    const chatInputRef = ref(null);
    const showScrollButton = ref(false);
    const previewImageUrl = ref('');
    const conversation = computed(() => chatStore.currentConversation);
    const headerAvatar = computed(() => {
      const conv = conversation.value;
      if (!conv || conv.type === 'group') return '';
      const other = (conv.members || []).find(m => String(m.id) !== String(currentUserId.value));
      if (other) return chatStore.getUserInfo(other.id).avatar;
      return '';
    });

    // 平台端用户头像颜色
    const avatarColors = {
      u1: 'bg-blue-500',
      u2: 'bg-primary-500',
      u3: 'bg-teal-500',
      u4: 'bg-orange-500',
      u5: 'bg-pink-500',
      u6: 'bg-indigo-500',
      u7: 'bg-rose-500',
      other: 'bg-slate-500'
    };

    // APP端用户头像颜色（使用绿色系区分）
    const appAvatarColors = {
      u1: 'bg-green-500',
      u2: 'bg-emerald-500',
      u3: 'bg-teal-500',
      u4: 'bg-lime-500',
      u5: 'bg-emerald-600',
      u6: 'bg-green-600',
      u7: 'bg-teal-600',
      other: 'bg-emerald-500'
    };
    function getAvatarColor(senderId, senderType) {
      // senderType=2 表示APP端用户，使用绿色系颜色
      if (senderType === 2) {
        return appAvatarColors[senderId] || appAvatarColors.other;
      }
      return avatarColors[senderId] || avatarColors.other;
    }
    function shouldShowDate(msg, index) {
      if (index === 0) return true;
      const prevMsg = chatStore.currentMessages[index - 1];
      if (!prevMsg) return false;
      const curr = new Date(msg.time);
      const prev = new Date(prevMsg.time);
      if (isNaN(curr.getTime()) || isNaN(prev.getTime())) return true;
      return curr - prev > 5 * 60 * 1000;
    }
    function formatMessageDate(timeStr) {
      if (!timeStr) return '';
      const date = new Date(timeStr);
      if (isNaN(date.getTime())) return '';
      const now = new Date();
      const isToday = date.toDateString() === now.toDateString();
      const time = date.toLocaleTimeString('zh-CN', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      });
      if (isToday) return time;
      const yesterday = new Date(now);
      yesterday.setDate(yesterday.getDate() - 1);
      if (date.toDateString() === yesterday.toDateString()) return `昨天 ${time}`;
      return `${date.toLocaleDateString('zh-CN', {
        month: '2-digit',
        day: '2-digit'
      })} ${time}`;
    }
    function handleSend(content) {
      chatStore.sendNewMessage(content);
      nextTick(() => scrollToBottom());
    }
    function handleSendFile(fileData) {
      chatStore.sendFileMessage(fileData.file);
      nextTick(() => scrollToBottom());
    }
    function handleSendImage(imageData) {
      chatStore.sendImageMessage(imageData.file);
      nextTick(() => scrollToBottom());
    }
    function handleReply(message) {
      chatStore.setReplyTo(message);
      chatInputRef.value?.focus();
    }
    function handleDeleteMessage(messageId) {
      chatStore.deleteMessage(messageId);
    }
    function scrollToBottom() {
      if (messagesContainer.value) {
        messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight;
      }
    }
    function handleScroll() {
      if (!messagesContainer.value) return;
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = messagesContainer.value;
      showScrollButton.value = scrollHeight - scrollTop - clientHeight > 200;

      // 滚动到顶部时加载更多历史消息
      if (scrollTop < 50 && !chatStore.messageLoading) {
        const prevHeight = scrollHeight;
        chatStore.loadMoreMessages().then(loaded => {
          if (loaded) {
            nextTick(() => {
              if (messagesContainer.value) {
                messagesContainer.value.scrollTop = messagesContainer.value.scrollHeight - prevHeight;
              }
            });
          }
        });
      }
    }
    watch(() => chatStore.currentMessages.length, () => nextTick(() => scrollToBottom()));
    watch(() => chatStore.currentConversationId, () => nextTick(() => scrollToBottom()), {
      flush: 'post'
    });

    // 消息加载完成后滚动到底部
    watch(() => chatStore.messageLoading, (loading, oldLoading) => {
      if (oldLoading && !loading) {
        nextTick(() => scrollToBottom());
      }
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [conversation.value.type !== 'group' && headerAvatar.value ? (_openBlock(), _createElementBlock("img", {
        key: 0,
        src: headerAvatar.value,
        class: "w-8 h-8 rounded-full object-cover flex-shrink-0"
      }, null, 8, _hoisted_4)) : conversation.value.type !== 'group' ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(["w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium text-white flex-shrink-0", conversation.value.type === 'internal' ? 'bg-primary-500' : 'bg-emerald-500'])
      }, _toDisplayString(conversation.value.name.slice(-2)), 3)) : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[6] || (_cache[6] = [_createElementVNode("svg", {
        class: "w-4 h-4 text-white",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
      })], -1)]))])), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("h3", _hoisted_8, _toDisplayString(conversation.value.name), 1), conversation.value.type === 'internal' ? (_openBlock(), _createElementBlock("span", _hoisted_9, "内部人员")) : conversation.value.type === 'customer' ? (_openBlock(), _createElementBlock("span", _hoisted_10, "C端客户")) : conversation.value.type === 'group' ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(conversation.value.memberCount) + "人", 1)) : _createCommentVNode("", true)]), conversation.value.type !== 'group' && conversation.value.online ? (_openBlock(), _createElementBlock("p", _hoisted_12, "在线")) : conversation.value.type !== 'group' ? (_openBlock(), _createElementBlock("p", _hoisted_13, "离线")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("button", {
        class: _normalizeClass(["p-2 rounded-lg transition-colors cursor-pointer", _unref(chatStore).messageSearchActive ? 'text-primary-500 bg-primary-50' : 'text-slate-400 hover:text-slate-600 hover:bg-slate-100']),
        title: "搜索聊天记录",
        onClick: _cache[0] || (_cache[0] = $event => _unref(chatStore).toggleMessageSearch())
      }, [...(_cache[7] || (_cache[7] = [_createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
      })], -1)]))], 2), _createElementVNode("button", {
        class: _normalizeClass(["p-2 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors cursor-pointer", _unref(chatStore).showInfoPanel ? 'text-primary-500 bg-primary-50' : '']),
        title: "会话详情",
        onClick: _cache[1] || (_cache[1] = $event => _unref(chatStore).toggleInfoPanel())
      }, [...(_cache[8] || (_cache[8] = [_createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
      })], -1)]))], 2)])]), _unref(chatStore).messageSearchActive ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_cache[9] || (_cache[9] = _createElementVNode("svg", {
        class: "absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
      })], -1)), _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(chatStore).messageSearchKeyword = $event),
        type: "text",
        placeholder: "在聊天记录中搜索...",
        class: "w-full pl-10 pr-4 py-1.5 text-sm bg-slate-50 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent",
        autofocus: ""
      }, null, 512), [[_vModelText, _unref(chatStore).messageSearchKeyword]])]), _unref(chatStore).messageSearchKeyword ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_unref(chatStore).messageSearchResults.length) + " 条结果 ", 1)) : _createCommentVNode("", true), _createElementVNode("button", {
        class: "p-1 text-slate-400 hover:text-slate-600 rounded transition-colors cursor-pointer",
        onClick: _cache[3] || (_cache[3] = $event => _unref(chatStore).toggleMessageSearch())
      }, [...(_cache[10] || (_cache[10] = [_createElementVNode("svg", {
        class: "w-4 h-4",
        fill: "none",
        stroke: "currentColor",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "2",
        d: "M6 18L18 6M6 6l12 12"
      })], -1)]))])])) : _createCommentVNode("", true), _createElementVNode("div", {
        ref_key: "messagesContainer",
        ref: messagesContainer,
        class: "flex-1 overflow-y-auto p-4 space-y-1 bg-slate-50/50 relative",
        onScroll: handleScroll
      }, [_unref(chatStore).messageLoading ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[11] || (_cache[11] = [_createElementVNode("div", {
        class: "flex items-center gap-2 text-slate-400 text-sm"
      }, [_createElementVNode("svg", {
        class: "w-4 h-4 animate-spin",
        fill: "none",
        viewBox: "0 0 24 24"
      }, [_createElementVNode("circle", {
        class: "opacity-25",
        cx: "12",
        cy: "12",
        r: "10",
        stroke: "currentColor",
        "stroke-width": "4"
      }), _createElementVNode("path", {
        class: "opacity-75",
        fill: "currentColor",
        d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      })]), _createTextVNode(" 加载消息中... ")], -1)]))])) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chatStore).currentMessages, (msg, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: msg.id
        }, [shouldShowDate(msg, index) ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("span", _hoisted_20, _toDisplayString(formatMessageDate(msg.time)), 1)])) : _createCommentVNode("", true), msg.type === 'system' ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("span", _hoisted_22, _toDisplayString(msg.content), 1)])) : (_openBlock(), _createBlock(MessageBubble, {
          key: 2,
          message: msg,
          "is-self": String(msg.senderId) === String(currentUserId.value) && msg.senderType === 1,
          "show-sender": conversation.value.type === 'group',
          "avatar-color": getAvatarColor(msg.senderId, msg.senderType),
          "conversation-type": conversation.value.type,
          members: conversation.value.members || [],
          "current-user-id": currentUserId.value,
          "cached-user": _unref(chatStore).getUserInfo(msg.senderId),
          onReply: handleReply,
          onDelete: handleDeleteMessage
        }, null, 8, ["message", "is-self", "show-sender", "avatar-color", "conversation-type", "members", "current-user-id", "cached-user"]))], 64);
      }), 128)), _unref(chatStore).messageSearchActive && _unref(chatStore).messageSearchKeyword && _unref(chatStore).currentMessages.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_23, [...(_cache[12] || (_cache[12] = [_createElementVNode("p", {
        class: "text-sm text-slate-400"
      }, "没有找到相关消息", -1)]))])) : _createCommentVNode("", true)], 64))], 544), _createVNode(_Transition, {
        name: "fade-up"
      }, {
        default: _withCtx(() => [showScrollButton.value ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "absolute bottom-28 right-6 w-9 h-9 bg-white shadow-lg border border-slate-200 rounded-full flex items-center justify-center text-slate-500 hover:text-primary-500 hover:border-primary-300 transition-colors cursor-pointer z-10",
          onClick: scrollToBottom
        }, [...(_cache[13] || (_cache[13] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M19 14l-7 7m0 0l-7-7m7 7V3"
        })], -1)]))])) : _createCommentVNode("", true)]),
        _: 1
      }), _createVNode(ChatInput, {
        ref_key: "chatInputRef",
        ref: chatInputRef,
        onSend: handleSend,
        onSendFile: handleSendFile,
        onSendImage: handleSendImage
      }, null, 512), (_openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(AppModal, {
        visible: Boolean(previewImageUrl.value),
        size: "none",
        "panel-class": "max-w-[90vw]",
        "z-index": 200,
        onClose: _cache[5] || (_cache[5] = $event => previewImageUrl.value = '')
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createElementVNode("img", {
          src: previewImageUrl.value,
          class: "max-w-[90vw] max-h-[90vh] object-contain rounded-lg"
        }, null, 8, _hoisted_25), _createElementVNode("button", {
          onClick: _cache[4] || (_cache[4] = $event => previewImageUrl.value = ''),
          class: "absolute -top-3 -right-3 flex h-8 w-8 items-center justify-center rounded-full bg-white shadow-lg text-slate-500 hover:text-slate-700 transition-colors cursor-pointer"
        }, [...(_cache[14] || (_cache[14] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M6 18L18 6M6 6l12 12"
        })], -1)]))])])]),
        _: 1
      }, 8, ["visible"])]))]);
    };
  }
};